import styled from 'styled-components'
import { Box } from '../../UI/Box'
import { H1 } from '../Typeography'

const Article = ({
  bannerUrl,
  title,
  content,
}: {
  bannerUrl: string
  title: string
  content: React.ReactNode
}) => {
  return (
    <Box dc g={48} padT={72} padB={72}>
      {bannerUrl && <ArticleBanner bannerUrl={bannerUrl} />}
      <ArticleBox dc g={48} mw="628px">
        <H1 uc>{title}</H1>
        <Box dc g={48}>
          {content}
        </Box>
      </ArticleBox>
    </Box>
  )
}

export default Article

const ArticleBanner = styled.div<{ bannerUrl: string }>`
  background: linear-gradient(
      0deg,
      var(--surface-minimal-primary, rgba(255, 255, 255, 0.06)) 0%,
      var(--surface-minimal-primary, rgba(255, 255, 255, 0.06)) 100%
    ),
    url(${({ bannerUrl }) => bannerUrl});
  background-size: cover;
  background-position: center;

  border-radius: var(--units-8, 8px);

  height: 126px;
  width: 100%;
  position: relative;
  overflow: hidden;
`

const ArticleBox = styled(Box)`
  margin: 0 auto;
`

export const ArticleContentBox = styled(Box)`
  flex-direction: column;
  gap: var(--units-16, 16px);

  svg {
    flex-shrink: 0;
  }
`

export const DisclaimerBox = styled.div`
  display: flex;
  max-width: 628px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--units-12, 12px);
  align-self: stretch;

  border-radius: var(--units-8, 8px);
  background: var(--surface-minimal-secondary, rgba(255, 255, 255, 0.08));
`

export const DisclaimerTitle = styled.h4`
  overflow: hidden;
  color: var(--text-primary, #fff);
  text-overflow: ellipsis;

  /* Web/Heading Space/L/Semibold */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Heading-L-L-size, 24px);
  font-style: normal;
  font-weight: var(--type-weight-Semibold, 600);
  line-height: var(--Heading-L-L-line-height, 32px); /* 133.333% */
`

export const DisclaimerText = styled.p`
  color: var(--text-secondary, #b1b1b1);

  /* Web/Text/L/Regular */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Text-L-L-size, 16px);
  font-style: normal;
  font-weight: var(--type-weight-Regular, 300);
  line-height: var(--Text-L-L-line-height, 20px); /* 125% */

  a {
    text-decoration: underline;
  }
`
